export const AuthenticationActionTypes = {
    LOGIN_REQUEST: '@@authentication/LOGIN_REQUEST',
    LOGIN_SUCCESS: '@@authentication/LOGIN_SUCCESS',
    LOGIN_FAILURE: '@@authentication/LOGIN_FAILURE',

    LOGOUT_REQUEST: '@@authentication/LOGOUT_REQUEST',
    LOGOUT_SUCCESS: '@@authentication/LOGOUT_SUCCESS',
    LOGOUT_FAILURE: '@@authentication/LOGOUT_FAILURE',
};
